var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { Component } from 'react';
import HierarchyItem from './HierarchyItem';
// Компонент для отображения иерархии объектов
var Hierarchy = /** @class */ (function (_super) {
    __extends(Hierarchy, _super);
    function Hierarchy() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Hierarchy.prototype.render = function () {
        var _a = this.props, items = _a.items, isCollapsible = _a.isCollapsible, className = _a.className, bordered = _a.bordered, isPaddingForButton = _a.isPaddingForButton;
        var itemsToRender = [];
        var levelCollapsed = null;
        items.forEach(function (item, index) {
            // Если родительский элемент свернут, то дочерний не отображаем
            if (levelCollapsed === null || item.level <= levelCollapsed) {
                itemsToRender.push(React.createElement(HierarchyItem, __assign({ key: 'item-' + index }, item, { bordered: bordered, isLeaf: index + 1 === items.length || item.level >= items[index + 1].level, isCollapseButton: isCollapsible, className: item.className, isPaddingForButton: isPaddingForButton })));
                if (item.collapsed) {
                    levelCollapsed = item.level;
                }
                else {
                    levelCollapsed = null;
                }
            }
        });
        return React.createElement("div", { className: 'hierarchy ' + (className ? className : '') }, itemsToRender);
    };
    return Hierarchy;
}(Component));
export default Hierarchy;
//# sourceMappingURL=Hierarchy.js.map